import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { InfoStocksTabEnum } from '../core/enums/info-stocks-tab.enum'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { InfoStocksDescriptionComponent } from './common/info-stocks-description/info-stocks-description.component'
import { InfoStocksStatisticsComponent } from './common/info-stocks-statistics/info-stocks-statistics.component'
import { TwelveDataService } from '@modules/twelve-data-module/services/twelve-data.service'
import { LiveTickerInterface } from '@modules/stocks-module/live-ticker/interfaces/live-ticker.interface'
import { InfoStocksAnalyticsComponent } from '@shared/components/trading/info/info-stocks/common/info-stocks-analytics/info-stocks-analytics.component'

@Component({
	selector: 'app-info-stocks',
	templateUrl: './info-stocks.component.html',
	styleUrl: './info-stocks.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [TwelveDataService],
	imports: [InfoStocksDescriptionComponent, InfoStocksStatisticsComponent, InfoStocksAnalyticsComponent],
})
export class InfoStocksComponent {
	protected readonly infoStocksTabEnum: typeof InfoStocksTabEnum = InfoStocksTabEnum

	public activeTab: InputSignal<InfoStocksTabEnum | undefined> = input<InfoStocksTabEnum | undefined>(undefined)
	public widget: InputSignal<WidgetInterface | null> = input<WidgetInterface | null>(null)
	public liveTicker: InputSignal<LiveTickerInterface | null> = input<LiveTickerInterface | null>(null)
}
